module.exports = __webpack_public_path__ + "img/inst-transformer1.60bae0cc.jpg";